export const aspectRatioLookup = [
  { label: '1.33 : 1', value: 1.333333333 },
  { label: '1.66 : 1', value: 1.666667 },
  { label: '1.78 : 1', value: 1.777777777778 },
  { label: '1.85 : 1', value: 1.85 },
  { label: '1.89 : 1', value: 1.8961 },
  { label: '2 : 1', value: 2 },
  { label: '2.1 : 1', value: 2.1 },
  { label: '2.2 : 1', value: 2.2 },
  { label: '2.35 : 1', value: 2.35 },
  { label: '2.39 : 1', value: 2.387 },
  { label: '2.40 : 1', value: 2.4 },
];

export const defaultAspectRatio = aspectRatioLookup[2];

export const descriptiveAspectRatioLookup = [
  { label: '1.33 : 1 (4:3)', value: 1.3333333 },
  { label: '1.66 : 1 (5:3)', value: 1.6666667 },
  { label: '1.78 : 1 (16:9)', value: 1.7777778 },
  { label: '1.85 : 1', value: 1.85 },
  { label: '1.89 : 1 (DCI)', value: 1.8962963 },
  { label: '2 : 1', value: 2 },
  { label: '2.1 : 1', value: 2.1 },
  { label: '2.2 : 1', value: 2.2 },
  { label: '2.35 : 1', value: 2.35 },
  { label: '2.39 : 1 (DCI)', value: 2.3869464 },
  { label: '2.40 : 1', value: 2.4 },
];

export const defaultDescriptiveAspectRatio =
  descriptiveAspectRatioLookup[2];

export const lensSqueezeFactorLookup = [
  { label: '1x (Spherical)', value: 1 },
  { label: '1.25x (Anamorphic)', value: 1.25 },
  { label: '1.3x (Anamorphic)', value: 1.3 },
  { label: '1.4x (Anamorphic)', value: 1.4 },
  { label: '1.5x (Anamorphic)', value: 1.5 },
  { label: '1.65x (Anamorphic)', value: 1.65 },
  { label: '1.8x (Anamorphic)', value: 1.8 },
  { label: '2x (Anamorphic)', value: 2 },
];

export const minAnamorphicSqueezeFactorLookup = [
  { label: '1.25x', value: 1.25 },
  { label: '1.3x', value: 1.3 },
  { label: '1.4x', value: 1.4 },
  { label: '1.5x', value: 1.5 },
  { label: '1.65x', value: 1.65 },
  { label: '1.8x', value: 1.8 },
  { label: '2x', value: 2 },
];

export const defaultLensSqueezeFactor = lensSqueezeFactorLookup[0];

export const framerateLookup = [
  { label: '23.98fps', value: 23.976 },
  { label: '24fps', value: 24 },
  { label: '25fps', value: 25 },
  { label: '29.98fps', value: 29.98 },
  { label: '30fps', value: 30 },
  { label: '50fps', value: 50 },
  { label: '60fps', value: 60 },
];

export const defaultFramerate = framerateLookup[1];

export const namFileTypeLookup = [
  { label: 'DPX 10-Bit', value: 3.99 },
  { label: 'DPX 16-Bit', value: 6.03 },
  { label: 'TIFF 16-Bit (uncompressed)', value: 6.03 },
  { label: 'EXR 16-Bit (uncompressed)', value: 6.03 },
  { label: 'EXR 16-Bit ZIP', value: 2.63 },
  { label: 'EXR 16-Bit PIZ', value: 2.63 },
];

export const defaultNamFileType = namFileTypeLookup[1];

export const bandwidthLookup = [
  { label: '50 Mbps', value: 50 },
  { label: '100 Mbps', value: 100 },
  { label: '200 Mbps', value: 200 },
  { label: '300 Mbps', value: 300 },
  { label: '400 Mbps', value: 400 },
  { label: '500 Mbps', value: 500 },
  { label: '750 Mbps', value: 750 },
  { label: '1 Gbps', value: 1000 },
  { label: '2 Gbps', value: 2000 },
  { label: 'Snowball', value: 4000 },
];

export const defaultBandwidth = bandwidthLookup[2];

export const alignmentLookup = [
  { label: 'Center', value: 'center' },
  { label: 'Top', value: 'top' },
  { label: 'Bottom', value: 'bottom' },
];

export const defaultAlignment = alignmentLookup[0];
